// assets/mb-opw-loader.js
(() => {
  const DEBUG = !!window.__MB_OPW_DEBUG;

  const log = (...args) => DEBUG && console.log("[mb-opw]", ...args);
  const warn = (...args) => DEBUG && console.warn("[mb-opw]", ...args);

  const hasCards = (root) => !!root && root.querySelectorAll(".mb-opw-card").length > 0;

  const setLoadingUI = (el, isLoading) => {
    if (!el) return;
    el.classList.toggle("is-loading", !!isLoading);
  };

  const safeCssEscape = (value) => {
    if (window.CSS && typeof window.CSS.escape === "function") return CSS.escape(value);
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  };

  const pickSource = (doc, sectionId) => {
    if (sectionId) {
      const sel = `[data-mb-opw][data-section-id="${safeCssEscape(sectionId)}"]`;
      const exact = doc.querySelector(sel);
      if (exact && hasCards(exact)) {
        log("pickSource: exact match has cards", sel);
        return exact;
      }
    }

    const candidates = Array.from(doc.querySelectorAll("[data-mb-opw].mb-opw"));
    const withCards = candidates.find(hasCards);
    if (withCards) {
      log("pickSource: fallback candidate with cards found");
      return withCards;
    }

    log("pickSource: no candidates with cards");
    return null;
  };

  const fetchSection = async (url) => {
    const res = await fetch(url, { credentials: "same-origin", cache: "no-store" });
    if (!res.ok) return null;
    const text = await res.text();
    return new DOMParser().parseFromString(text, "text/html");
  };

  const fetchAndSwap = async (el) => {
    if (!el) return;

    const alreadyLoaded = el.dataset.mbOpwLoaded === "1";
    const alreadyHasCards = el.querySelectorAll(".mb-opw-card").length > 0;
    if (alreadyLoaded && alreadyHasCards) {
      log("skip: already loaded and has cards");
      return;
    }

    const url = el.dataset.url;
    if (!url) {
      warn("skip: no data-url on element");
      return;
    }

    setLoadingUI(el, true);
    const sectionId = el.dataset.sectionId || "";

    try {
      // 1. Try the primary URL (intent=complementary)
      log("fetch (complementary):", url);
      let doc = await fetchSection(url);
      let source = doc && pickSource(doc, sectionId);

      // 2. Fallback: swap intent to related if complementary returned no cards
      if (!source && url.includes("intent=complementary")) {
        const relatedUrl = url.replace("intent=complementary", "intent=related");
        log("complementary empty, retrying with intent=related:", relatedUrl);
        doc = await fetchSection(relatedUrl);
        source = doc && pickSource(doc, sectionId);
      }

      if (!source) {
        setLoadingUI(el, false);
        warn("no cards from complementary or related; hiding block");
        el.innerHTML = "";
        el.style.display = "none";
        return;
      }

      el.innerHTML = source.innerHTML;

      const cardCount = el.querySelectorAll(".mb-opw-card").length;
      log("swapped. cardCount:", cardCount);

      if (cardCount > 0) {
        el.dataset.mbOpwLoaded = "1";
        el.style.removeProperty("display");
      }

      setLoadingUI(el, false);
    } catch (err) {
      console.error("[mb-opw] fetchAndSwap error:", err);
      setLoadingUI(el, false);
    }
  };

  const init = (el) => {
    if (!el || el.dataset.mbOpwInit === "1") return;
    el.dataset.mbOpwInit = "1";
    log("init", el);

    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries, observer) => {
          const ent = entries[0];
          if (!ent || !ent.isIntersecting) return;
          observer.unobserve(ent.target);
          fetchAndSwap(ent.target);
        },
        { rootMargin: "0px 0px 600px 0px" }
      );
      io.observe(el);
    } else {
      fetchAndSwap(el);
    }
  };

  const boot = () => {
    const els = document.querySelectorAll(".mb-opw[data-mb-opw]");
    log("boot. found:", els.length);
    els.forEach(init);
  };

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
